import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
    button: {
        margin: theme.spacing.unit,
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
})

class AccidentAge extends Component {
    cookies = new Cookies()
    constructor(props) {
        super(props)

        this.state = {
            accidentAge: this.props.accidentAge,
            visible: true,
            snackstr: "",
            showSnack: false,
            snackMode: "success",
        }
    }
    componentDidMount() {
        console.log(this.props.therapySlideOld)
    }

    handleClickcloseTasckBar = (event) => {
        this.setState({ showSnack: false })
    }

    handleChangeSlideoldMax = (event) => {
        var temparray = this.state.accidentAge
        temparray.accident_price_age_max = event
        this.setState({ accidentAge: temparray })
    }
    handleChangeSlideoldMin = (event) => {
        var temparray = this.state.accidentAge
        temparray.accident_price_age_min = event
        this.setState({ accidentAge: temparray })
    }

    handleChangeSlideoldPercent = (event) => {
        var temparray = this.state.accidentAge
        temparray.accident_price_age_price = event
        this.setState({ accidentAge: temparray })
    }

    modifyNewInstalmentCondition = () => {
        const { accidentAge } = this.state

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "modify_price_age")
        fd.append("accident_price_age_id", accidentAge.accident_price_age_id)
        fd.append("accident_price_age_accident_price_id", accidentAge.accident_price_age_accident_price_id)
        fd.append("accident_price_age_price", accidentAge.accident_price_age_price)
        fd.append("accident_price_age_min", accidentAge.accident_price_age_min)
        fd.append("accident_price_age_max", accidentAge.accident_price_age_max)

        xhttp.open("POST", `${constants.BASE_URL}/accident`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    deleteInstalmentCondition = () => {
        const { accidentAge } = this.state

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "delete_price_age")

        fd.append("accident_price_age_id", accidentAge.accident_price_age_id)
        xhttp.open("POST", `${constants.BASE_URL}/accident`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    render() {
        const { classes } = this.props
        const { snackMode, snackstr, showSnack, visible, accidentAge } = this.state
        if (visible) {
            return (
                <Grid container spacing={3}>
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid item xs={3}>
                        <FloatingLabelInput
                            type="number"
                            placeholder="از تعداد"
                            handleInputt={this.handleChangeSlideoldMin}
                            value={accidentAge.accident_price_age_min}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FloatingLabelInput
                            type="number"
                            placeholder="تا تعداد"
                            handleInputt={this.handleChangeSlideoldMax}
                            value={accidentAge.accident_price_age_max}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FloatingLabelInput
                            type="percent"
                            placeholder="درصد"
                            handleInputt={this.handleChangeSlideoldPercent}
                            value={accidentAge.accident_price_age_price}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <Fab
                                className={classes.small}
                                style={{ background: "#44b700" }}
                                aria-label="edit"
                                onClick={this.modifyNewInstalmentCondition}
                            >
                                <EditIcon />
                            </Fab>

                            <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                <DeleteIcon />
                            </Fab>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
            )
        } else {
            return null
        }
    }
}
export default withStyles(styles)(AccidentAge)
